import React from "react";
import { useNavigate } from "react-router-dom";
import { IoMdHome, IoMdArrowBack } from "react-icons/io";

const Nopagefound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center px-6">
      {/* Big 404 */}
      <h1 className="text-9xl font-extrabold text-gray-800">404</h1>
      <p className="text-xl text-gray-600 mt-4">
        Oops! The page you’re looking for doesn’t exist.
      </p>

      {/* Illustration emoji or icon */}
      <div className="text-6xl mt-6 animate-bounce">🚧</div>

      {/* Action Buttons */}
      <div className="flex gap-4 mt-8">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 px-5 py-2 rounded-xl bg-gray-200 text-gray-700 hover:bg-gray-300 font-medium transition"
        >
          <IoMdArrowBack size={20} />
          Go Back
        </button>

        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 px-5 py-2 rounded-xl bg-teal-600 text-white hover:bg-teal-700 font-medium transition"
        >
          <IoMdHome size={20} />
          Home
        </button>
      </div>
    </div>
  );
};

export default Nopagefound;
